/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Type_OpeningInputs */

const vi_customer_debt_type_opening = /** @type {(inputs: Customer_Debt_Type_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đầu kỳ`)
};

/**

* @param {Customer_Debt_Type_OpeningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_type_opening = /** @type {((inputs?: Customer_Debt_Type_OpeningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Type_OpeningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_type_opening(inputs)
});